// extracted by mini-css-extract-plugin
export var orderDetails = "_ra-2";
export var orderImage = "_ra-1";
export var orderMeta = "_ra-3";
export var orderSummary = "_ra-0";
export var rightArrow = "_ra-4";